import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Map from "../components/Map";
import FormContainer from "../components/FormContainer";
import TextByLetter from "../components/TextByLetter";
import ClinicList from "../components/ClinicList";
import { Howl } from "howler";
import { notify } from "../components/notify";
import { USER_REGISTER_RESET } from "../constants/userConstants";
import Help from "../components/Help";
import { Col, Image, Row } from "react-bootstrap";
import { FaHome, FaListAlt } from "react-icons/fa";
import prefixes from "../data/prefixes";

const ClinicListScreen = () => {
  const userLogin = useSelector((state) => state.userLogin);
  const { loading, userInfo } = userLogin;

  const clinicsOfUserStore = useSelector((state) => state.clinicsOfUserStore);
  const { userClinics } = clinicsOfUserStore;

  const registeredUser = useSelector((state) => state.registeredUser);
  const { userInfo: newUser } = registeredUser;

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userInfo) {
      if (!loading) {
        navigate(`/login-screen?returnFrom=${location.pathname}`);
      }
    }
    if (newUser) {
      notify({
        title: "Register Success",
        message: `Your account is created successfully`,
        type: "success",
        duration: 3000,
      });
      var sound = new Howl({
        src: `/success.mp3`,
      });
      sound.play();
      dispatch({ type: USER_REGISTER_RESET });
    }
  }, [userInfo, navigate, newUser, userClinics, loading]);
  return (
    <FormContainer>
      <Map
        titles={[
          {
            idx: "1",
            label: (
              <>
                <FaHome /> Home
              </>
            ),
            path: `/`,
            active: false,
          },
          {
            idx: "2",
            label: `Clinic List Screen`,
            path: ``,
            active: true,
          },
        ]}
      />
      <TextByLetter
        text={
          userInfo &&
          `Welcome back ${
            prefixes.find(
              (p) => p._id.toString() === userInfo.prefixId?.toString(),
            )?.name
          } ${userInfo.firstName},`
        }
        speed={150}
        look="subtitle"
      />{" "}
      <Row className="mb-3 justify-content-center">
        {" "}
        <Image src="/images/00.jfif" width={400} />
      </Row>
      <Row className="text-center text-primary">
        <Col>
          <h3>
            <FaListAlt /> YOUR CLINIC LIST
          </h3>
        </Col>
      </Row>
      <ClinicList />
      <Help />
    </FormContainer>
  );
};

export default ClinicListScreen;
